module.exports = __webpack_public_path__ + "img/foreign-outbounds.b126ce0c.png";